// Mutation hook - test polaczenia IMAP dla zapisanej skrzynki.
// POST /api/ui/sales-crm/mailbox/test-imap
// Brak request body. Backend uzywa danych z zapisanej skrzynki zalogowanego handlowca.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { ITestConnectionResponse } from 'api/types/mailbox';

const testImapConnection = (): Promise<ITestConnectionResponse> =>
  axios.post('/sales-crm/mailbox/test-imap');

export const useTestImapConnection = (
  options?: UseMutationOptions<ITestConnectionResponse, IError, void>
) =>
  useMutation<ITestConnectionResponse, IError, void>(testImapConnection, options);
